import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const notifications = [{
  flagCode: 'us',
  countryName: 'United States',
  location: 'New York, USA',
  name: 'Sarah Jenkins',
  initials: 'SJ',
  time: '5 minutes ago'
}, {
  flagCode: 'gb',
  countryName: 'United Kingdom',
  location: 'London, UK',
  name: 'David Smith',
  initials: 'DS',
  time: '12 minutes ago'
}, {
  flagCode: 'ca',
  countryName: 'Canada',
  location: 'Toronto, Canada',
  name: 'Emily Chen',
  initials: 'EC',
  time: '18 minutes ago'
}, {
  flagCode: 'au',
  countryName: 'Australia',
  location: 'Sydney, Australia',
  name: 'Michael Brown',
  initials: 'MB',
  time: '27 minutes ago'
}, {
  flagCode: 'ie',
  countryName: 'Ireland',
  location: 'Dublin, Ireland',
  name: 'Jessica Walsh',
  initials: 'JW',
  time: '41 minutes ago'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const timer = window.setTimeout(() => setIsVisible(true), 3000);
    return () => window.clearTimeout(timer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = window.setTimeout(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(previous => (previous + 1) % notifications.length);
          setIsVisible(true);
        }
      }, 1500);
    }, 5000);
    return () => window.clearTimeout(hideTimer);
  }, [currentIndex, isDismissed, isVisible]);
  if (isDismissed) return null;
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none w-full px-4 flex justify-center" data-id="element-211" data-mp="yk66s9gzh8kz"><AnimatePresence mode="wait" data-id="element-212" data-mp="3nca7lfgnka96">{isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-dark-card border border-gold/30 rounded-xl p-3.5 shadow-[0_4px_30px_rgba(212,175,55,0.25)] w-full max-w-[360px] pointer-events-auto relative" data-id="element-213" data-mp="3n8w23ycozkxi">
      <button type="button" onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors" aria-label="Close notification" data-id="element-214" data-mp="3asd6eyc3fqou"><X size={14} data-id="element-215" data-mp="31z9tcr5d1fuq" /></button>
      <div className="flex items-center gap-3" data-id="element-216" data-mp="31z01ey0r8yme"><div className="relative shrink-0" data-id="element-217" data-mp="36rji43uqo9vf"><div className="w-11 h-11 rounded-full bg-gold-gradient flex items-center justify-center text-black font-bold text-sm" data-id="element-218" data-mp="36rt8hsjp4j1n">{current.initials}</div><img src={`https://flagcdn.com/w40/${current.flagCode}.png`} alt={`${current.countryName} flag`} className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-dark-card shadow" data-id="element-219" data-mp="2s0ao7ijt02ch" /></div><div className="flex-1 min-w-0 pr-4" data-id="element-220" data-mp="2n2slwb0akldg"><div className="flex items-center gap-1.5 text-[11px] text-gray-400 mb-0.5" data-id="element-221" data-mp="2n1zbn024jdqk"><img src={`https://flagcdn.com/w20/${current.flagCode}.png`} alt="" className="w-4 h-3 rounded-sm object-cover" data-id="element-222" data-mp="24e8aybueaefk" /><span className="truncate" data-id="element-223" data-mp="1zgf9fw41e8lm">{current.location}</span></div><p className="text-white text-[13px] leading-snug" data-id="element-224" data-mp="1zi03lkmfvpiy"><span className="font-bold" data-id="element-225" data-mp="2dghjiw63rxqb">{current.name}</span>{' '}<span className="text-gray-300" data-id="element-226" data-mp="28gbpj9cd1z52">purchased Aerial Silks Teacher Ready™</span></p><div className="flex items-center gap-1.5 text-[10px] text-green-400 font-medium mt-1" data-id="element-227" data-mp="28ig3kk3z4ej2"><span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" data-id="element-228" data-mp="2nc1g7kshr0g4" /><ShoppingBag size={10} data-id="element-229" data-mp="2ifaxeppaxqr0" /><span data-id="element-230" data-mp="2idzvywjbwv32">Verified purchase • {current.time}</span></div></div></div>
    </motion.div>}</AnimatePresence></div>;
}